import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-b-com-honours-program',
  templateUrl: './b-com-honours-program.component.html',
  styleUrls: ['./b-com-honours-program.component.scss']
})
export class BComHonoursProgramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
